import { Component, State, h } from '@stencil/core';

@Component({
  tag: 'login-kia',
  styleUrl: 'login.scss',
  shadow: true,
})
export class MyComponent {
  @State() password: string = '';
  @State() pathname: string = '';
  @State() error: string = '';
  @State() loggedIn: boolean = false;
  @State() message: string = 'Hello there tjänstebilsidan';
  @State() testModelCode: string = 'ASW5';

  handleChange(e: any) {
    this.password = e.target.value;
  }

  handleKeyPress(e: any) {
    if (e.code === 'Enter') {
      this.handleLogin();
    }
  }

  handleLogin() {
    if (!process.env.PASSWORD || this.password === process.env.PASSWORD) {
      this.loggedIn = true;
      window.localStorage.setItem('loggedIn', 'true');
    } else {
      this.error = 'Fel lösenord';
    }
  }

  async componentDidRender() {
    this.pathname = window.location.pathname;
    window.localStorage.getItem('loggedIn') === 'true' ? (this.loggedIn = true) : (this.loggedIn = false);
  }

  navItems = ['prislista', 'priskort', 'privatleasing', 'billån', 'businessleasing'];

  render() {
    return (
      <div>
        {!this.loggedIn ? (
          <div class="login">
            <h2>Ange lösenord</h2>
            <input onKeyPress={e => this.handleKeyPress(e)} type="password" value={this.password} onInput={event => this.handleChange(event)} />
            <button onClick={() => this.handleLogin()}>Logga in</button>
            <p>{this.error}</p>
          </div>
        ) : (
          <div>
            <nav>
              <ul>
                {this.navItems.map(i => (
                  <li>
                    <a href={`/${i}`}>{i}</a>
                  </li>
                ))}
              </ul>
            </nav>
            <div class="title">
              <h2>Testmiljö för kias prislista</h2>
              <p>Data kommer från dev admin</p>
              <a target="_blank" href="https://kia.dev.afonso.se/admin/login">
                https://kia.dev.afonso.se/admin/login
              </a>
            </div>
            {this.pathname === '/prislista' && <kia-prislista />}
            {this.pathname === '/priskort' && <kia-modeldemo />}
            {this.pathname === '/privatleasing' && <kia-prislista-privatleasing demo />}
            {this.pathname === '/bill%C3%A5n' && <kia-prislista-billan demo />}
            {this.pathname === '/businessleasing' && <kia-prislista-business demo />}
          </div>
        )}
      </div>
    );
  }
}

categories: [];
